export const hejHomDeviceListConstant = {
  IrAirconditioner: 'IrAirconditioner',
  SmartPlugMini: 'SmartPlugMini',
  ZigbeeSwitch3: 'ZigbeeSwitch3',
};
